(() => {
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-motion-cookie-preferences]');
    if (!button || button.disabled) return;

    const status = button.parentElement.querySelector('[data-motion-cookie-status]');
    status.hidden = true;
    status.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Shopify privacy banner is unavailable');
      }
      // Open Shopify's dialog; consent changes only through the visitor's choices.
      await window.privacyBanner.showPreferences();
    } catch {
      status.textContent = button.dataset.errorMessage;
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
